module.exports = __webpack_public_path__ + "static/media/hidden.496e1637.svg";